import { HiOutlineVideoCamera } from 'react-icons/hi2';
import { BiDollar } from 'react-icons/bi';
import { IoTicketOutline } from 'react-icons/io5';
import { MdCheckCircle, MdLock } from 'react-icons/md';
import { TbTrendingUp } from 'react-icons/tb';
import { RiShieldCheckLine } from 'react-icons/ri';

export default function PredictionMarkets() {
  const steps = [
    {
      id: 1,
      icon: <HiOutlineVideoCamera />,
      title: 'Pick a video',
      description: 'Choose a video and select which view range you think it will land in.',
      gradient: 'purple',
      exampleTitle: 'Example prediction',
      exampleQuestion: '"How many views will this video reach?"',
      exampleOptions: 'Options: 0-50k, 50k-200k, 200k-500k, 500k+',
      timelineIcon: <MdCheckCircle />,
      timelineText: 'Prediction resolves',
      timelineDetail: 'After 24 hours'
    },
    {
      id: 2,
      icon: <BiDollar />,
      title: 'Bet in USDC',
      description: 'Place your bet using USDC on your chosen range. Your funds go into escrow.',
      gradient: 'cyan',
      exampleTitle: 'Your bet',
      exampleAmount: '100 USDC',
      exampleRange: 'Range: 50k-200k views',
      examplePayout: 'Potential payout: 280 USDC (2.8x)',
      timelineIcon: <TbTrendingUp />,
      timelineText: 'Oracle checks views',
      timelineDetail: 'Target hit or missed?'
    },
    {
      id: 3,
      icon: <IoTicketOutline />,
      title: 'Save on chain',
      description: 'Your prediction is saved on chain. It\'s proof of your bet and your key to rewards.',
      gradient: 'yellow',
      exampleTitle: 'Prediction #8472',
      exampleStatus: 'Saved on chain',
      timelineIcon: <MdCheckCircle />,
      timelineText: 'Winners share the pot',
      timelineDetail: 'Share the pot'
    }
  ];

  const features = [
    {
      icon: <MdLock />,
      title: 'Transparent escrow',
      description: 'All USDC is held in smart contracts. No custody risk.',
      color: 'purple'
    },
    {
      icon: <RiShieldCheckLine />,
      title: 'On-chain resolution',
      description: 'Oracle data determines outcomes. Fully verifiable.',
      color: 'cyan'
    },
    {
      icon: <TbTrendingUp />,
      title: 'Automatic payouts',
      description: 'Winners receive their share instantly when resolved.',
      color: 'yellow'
    }
  ];

  return (
    <section className="section prediction-markets">
      <div className="container">
        <div className="section-header text-center">
          <h1>How prediction markets work</h1>
          <p>Bet on video virality. Each prediction is saved on chain. Winners share the pot.</p>
        </div>

        <div className="pm-workflow-container">
          <div className="pm-workflow-steps">
            {steps.map((step) => (
              <div key={step.id} className="pm-workflow-step">
                <div className={`pm-step-icon-wrapper gradient-${step.gradient}`}>
                  <div className="pm-step-icon">{step.icon}</div>
                </div>

                <h3>{step.title}</h3>
                <p className="pm-step-description">{step.description}</p>

                <div className="pm-example-card">
                  <div className="pm-example-header">{step.exampleTitle}</div>
                  <div className="pm-example-content">
                    {step.id === 1 && (
                      <>
                        <div className="pm-example-question">{step.exampleQuestion}</div>
                        <div className="pm-example-options">{step.exampleOptions}</div>
                      </>
                    )}
                    {step.id === 2 && (
                      <>
                        <div className="pm-example-amount">{step.exampleAmount}</div>
                        <div className="pm-example-range">{step.exampleRange}</div>
                        <div className="pm-example-payout">{step.examplePayout}</div>
                      </>
                    )}
                    {step.id === 3 && (
                      <>
                        <div className="pm-example-nft">{step.exampleTitle}</div>
                        <div className="pm-example-status">
                          <MdCheckCircle /> {step.exampleStatus}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}

            {steps.map((step, index) => (
              <div key={index} className="pm-step-timeline">
                <div className="pm-timeline-icon">{step.timelineIcon}</div>
                <div className="pm-timeline-text">
                  <div className="pm-timeline-title">{step.timelineText}</div>
                  <div className="pm-timeline-detail">{step.timelineDetail}</div>
                </div>
              </div>
            ))}

          </div>


        </div>
        <div className="pm-features-grid">
          {features.map((feature, index) => (
            <div key={index} className={`pm-feature-card feature-${feature.color}`}>
              <div className="pm-feature-icon">{feature.icon}</div>
              <div className="pm-feature-content">
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
